<fr-dashboard [verticalPadding]="false">
  <cat-dashboard-card-list (search)="search.execute($event)" [items]="queries$ | async"
                           [mode]="preparedQueryMode" [simpleSettings]="preparedQuerySimple"></cat-dashboard-card-list>
</fr-dashboard>
